

























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import Button from '../common/inputs/Button.vue';
import AppDialog from '../common/Dialog.vue';
import DialogContent from '../common/DialogContent.vue';
import InputField from '../common/inputs/InputField.vue';
import { SavedSearchFilters } from '@/store/modules/searchInterfaces';
import { SearchModule } from '@/store/modules/search';

@Component({
  components: {
    Button,
    AppDialog,
    InputField,
    DialogContent
  }
})
export default class SearchFiltersActions extends Vue {
  name = '';
  touched = false;

  get error() {
    if (!this.touched) {
      return '';
    }

    return !this.name
      ? 'Skriv et navn'
      : !this.isSavedFilterNameUnique(this.name)
      ? 'Dette navn er allerede brugt, indtast venligst et nyt'
      : '';
  }

  saveFiltersDialogOpen = false;

  submitSaveFilters() {
    this.touched = true;
    if (!!this.error) {
      return;
    }

    SearchModule.saveFilters(this.name);
    this.closeSaveFilterDialog();
    this.name = '';
    this.touched = false;
  }

  onNameChange(name: string) {
    this.name = name;
  }

  toggleSaveFiltersDialog() {
    this.saveFiltersDialogOpen = !this.saveFiltersDialogOpen;
  }
  closeSaveFilterDialog() {
    this.saveFiltersDialogOpen = false;
  }

  async clearFilters() {
    await SearchModule.resetFilters();
    this.$emit('reset');
  }

  private isSavedFilterNameUnique(name: string) {
    const filternameExists =
      SearchModule.savedFilters?.findIndex(({ text }) => text.toLowerCase() === name.toLowerCase()) >= 0;
    return !filternameExists;
  }

  get filtersTouched() {
    return SearchModule.filtersTouched;
  }
}
